import React from 'react';
import close from '../../../../img/close.svg';
import { Link } from "react-scroll";

export default class Times extends React.Component  {
    constructor(props) {
        super(props);
        this.state = {
            vis: false,
        }

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.setState({vis: !this.state.vis});
    }

    render() {
        return (
            <>
                <button className='agenda_btn' onClick={this.handleClick}>SHOW ABSTRACT</button>
                {this.state.vis && <div onClick={this.handleClick} className='popup' key={`popup-${this.props.key}`}>
                    <div className='popup_container'>
                        <img className='popup_close' onClick={this.handleClick} src={close} alt="" />
                        <h4 onClick={this} className='popup_title'>"{this.props.title}"</h4>
                        <p onClick={this} className='popup_abstract'>{this.props.abstract}</p>
                        <Link
                        activeClass="active"
                        to='tickets'
                        spy={true}
                        smooth={true}
                        offset={-10}
                        className='button popup_btn--inside'
                        onClick={this.handleClick} 
                        >
                        Get ticket
                        </Link>
                    </div>
                </div>}
            </>
        )
    }
}